module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('general-item', {
    attrs: {
      "format": "slider"
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.in_a_slider')))]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.one_screen_apper_right')))])])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-a380dbb2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/types/items/Slider.vue
 ** module id = 895
 ** module chunks = 1
 **/